import { gql } from '@apollo/client';

export const FEE_MARKUP_CORE_FIELDS = gql`
  fragment FeeMarkupCoreFields on FeeMarkup {
    id
    feeType
    markupType
    amount
    defaultMarkup
  }
`;

export const UPDATE_FEE_MARKUP = gql`
  ${FEE_MARKUP_CORE_FIELDS}
  mutation UpdateFeeMarkup (
    $sellerId: ID
    $feeType: String!
    $markupType: String!
    $amount: Decimal!
  ) {
    updateFeeMarkup (
      sellerId: $sellerId
      feeType: $feeType
      markupType: $markupType
      amount: $amount
    ) {
      feeMarkup  {
        ...FeeMarkupCoreFields
      }
      errors { path, message }
    }
  }
`;
